import Vue from "vue";
import VueI18n from "vue-i18n";
import store from '../../store/store.js';

import cnLocal from "./cn/index.js"//中文
import enLocal from './en/index.js'//英文
import hkLocal from './hk/index.js'//繁体
import jpLocal from './jp/index.js'//日文
import koLocal from './ko/index.js'//韩语
import esLocal from './es/index.js'//西班牙语
import inLocal from './in/index.js'//印地语
import chLocal from './ch/index.js'//印尼语
import trLocal from './tr/index.js'//土耳其
import thLocal from './th/index.js'//泰语
import ptLocal from './pt/index.js'//葡萄牙语
import arLocal from './ar/index.js'//阿拉伯语
import deLocal from './de/index.js'//德语
import frLocal from './fr/index.js'//法语
import ruLocal from './ru/index.js'//俄语


//引入UI框架语言配置---elementui
import plLocal from './pl/index.js'//Polski

import locale from 'element-ui/lib/locale';
import elenlocale from 'element-ui/lib/locale/lang/en'
import elzhCNlocale from 'element-ui/lib/locale/lang/zh-CN'
import elzhTWlocale from 'element-ui/lib/locale/lang/zh-TW'
import eljalocale from 'element-ui/lib/locale/lang/ja'
import elfrlocale from 'element-ui/lib/locale/lang/fr'
import elrulocale from 'element-ui/lib/locale/lang/ru-RU'

import elpllocale from 'element-ui/lib/locale/lang/pl'

Vue.use(VueI18n);
const messagess = {
  'en_US': Object.assign(enLocal, elenlocale),
  'zh_CN': Object.assign(cnLocal, elzhCNlocale),
  'zh_HK': Object.assign(hkLocal, elzhTWlocale,),
  'ja_JP': Object.assign(jpLocal, eljalocale,),
  'ko_KR': Object.assign(koLocal, elenlocale),
  'es_ES': Object.assign(esLocal, elenlocale),
  'en_IN': Object.assign(inLocal, elenlocale),
  'it_CH': Object.assign(chLocal, elenlocale),
  'tr_TR': Object.assign(trLocal, elenlocale),
  'th_TH': Object.assign(thLocal, elenlocale),
  'pt_PT': Object.assign(ptLocal, elenlocale),
  'ar_SA': Object.assign(arLocal, elenlocale),
  'de_DE': Object.assign(deLocal, elenlocale),
  'fr_FR': Object.assign(frLocal, elfrlocale),
  'ru_RU': Object.assign(ruLocal, elrulocale),
  'pl_PL': Object.assign(plLocal, elpllocale),
}
function detectBrowserLanguage() {
  const nav = navigator;
  const browserLanguage = nav.language
  const lang1 = browserLanguage == 'zh-TW' ? 'zh-HK' : browserLanguage;
  const lang = lang1.replace(/-/g, "_");
  if (lang in messagess) {
    return lang;
  } else {
    return 'en_US'; // 默认语言
  }

}
const i18n = new VueI18n({
  locale: detectBrowserLanguage(),
  messages: {
    'en_US': Object.assign(enLocal, elenlocale),
    'zh_CN': Object.assign(cnLocal, elzhCNlocale),
    'zh_HK': Object.assign(hkLocal, elzhTWlocale,),
    'ja_JP': Object.assign(jpLocal, eljalocale,),
    'ko_KR': Object.assign(koLocal, elenlocale),
    'es_ES': Object.assign(esLocal, elenlocale),
    'en_IN': Object.assign(inLocal, elenlocale),
    'it_CH': Object.assign(chLocal, elenlocale),
    'tr_TR': Object.assign(trLocal, elenlocale),
    'th_TH': Object.assign(thLocal, elenlocale),
    'pt_PT': Object.assign(ptLocal, elenlocale),
    'ar_SA': Object.assign(arLocal, elenlocale),
    'de_DE': Object.assign(deLocal, elenlocale),
    'fr_FR': Object.assign(frLocal, elfrlocale),
    'ru_RU': Object.assign(ruLocal, elrulocale),
    'pl_PL': Object.assign(plLocal, elpllocale),
  },
  silentTranslationWarn: true
});
locale.i18n((key, value) => i18n.t(key, value))
export default i18n;



// WEBPACK FOOTER //
// ./src/assets/lang/index.js